function getRatings(likes, dislikes, opinionCodes) {
  return {
    likes,
    dislikes,
    positiveRatingPercentage: (100 * likes) / (likes + dislikes) || 0,
    negativeRatingPercentage: (100 * dislikes) / (likes + dislikes) || 0,
    opinionCodes,
  }
}

function serviceMapper(data, timePeriodMetric, slug, serviceModuleName) {
  const likes = data.channel.total_applet_likes
  const dislikes = data.channel.total_applet_dislikes
  const opinionCodes = data.channel.total_applet_opinion_codes
  return {
    serviceModuleName,
    ratings: getRatings(likes, dislikes, opinionCodes),
    metrics: data.service_metrics.metrics.map(metric => ({
      disables_daily: metric.applet_disables_daily,
      enables_daily: metric.applet_enables_daily,
      successful_runs_daily: metric.applet_runs_daily,
      metric_date: metric.metric_date,
      unsuccessful_runs_daily: metric.unsuccessful_applet_runs_daily,
      run_success_rate_daily:
        (100 * metric.applet_runs_daily) /
        (metric.applet_runs_daily +
          (metric.unsuccessful_applet_runs_daily || 0)),
    })),
  }
}

function suggested_applet_query_params(normalizedApplet, serviceModuleName) {
  const trigger = normalizedApplet.permissions
    .find(p => p.id.includes("/triggers/"))
    .id.replace("/triggers/", "")
  const action = normalizedApplet.permissions
    .find(p => p.id.includes("/actions/"))
    .id.replace("/actions/", "")

  if (
    "applet" === normalizedApplet.type &&
    (normalizedApplet.service_slug !== serviceModuleName ||
      (normalizedApplet.service_slug === serviceModuleName &&
        normalizedApplet.by_service_owner === false))
  ) {
    return `?trigger_module_name=${trigger}&action_module_name=${action}`
  }
}

function appletMapper(data, timePeriodMetric, slug, serviceModuleName) {
  const normalizedApplet = data.normalized_applets[0]
  const likes = normalizedApplet.applet_feedback_count?.like
  const dislikes = normalizedApplet.applet_feedback_count?.dislike
  const opinionCodes = normalizedApplet.applet_opinion_count || {}

  return {
    serviceModuleName,
    ratings: getRatings(likes, dislikes, opinionCodes),
    metrics: normalizedApplet.applet_metrics.map(metric => ({
      ...metric,
      run_success_rate_daily:
        (100 * metric.successful_runs_daily) /
        (metric.successful_runs_daily + metric.unsuccessful_runs_daily),
    })),
    suggestedAppletQueryParams:
      suggested_applet_query_params(normalizedApplet, serviceModuleName) || "",
    slug,
  }
}

export { serviceMapper, appletMapper }
